import { set } from "lodash";
import { Calendar } from "primereact/calendar";
import { OverlayPanel } from "primereact/overlaypanel";
import React, { useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem, Input } from "reactstrap";
import  "src/components/UI/commonUI.styles.scss";
import { convertToMonthYear, hasAdminOrEmployeeRoleHandler } from "src/helpers/common_helpers";
import FeatherIcon from "feather-icons-react";
import "./button.scss";
import { useSelector } from "react-redux";
import { RootReducerState } from "src/store/reducers";

interface BreadcrumbProps {
  breadcrumbItem: string;
  title?: string;
  titlePath?: string;
  button?:boolean;
  setDate?:any
  date?:any;
  showDetail:boolean;
  setShowDetail:any;
  myJobsOnly?:any;
  setMyJobsOnly?:any;
}
const monthConverter = () =>{

    const data=new Date()
    const year =data.getFullYear()
    const month =data.getMonth()+1
    const monthFormat = month>9 ? month : `0${month}`
    
    return `${year}-${monthFormat}`
  
  
}
const DashboardBreadcrumb = ({ breadcrumbItem, title, titlePath = "", setDate,date,showDetail,setShowDetail,myJobsOnly,setMyJobsOnly}: BreadcrumbProps) => {
  const { profile } = useSelector((state: RootReducerState) => state.profilesReducer);
    const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
    const calendarRef = useRef<any>(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const toggleCalendar = (e:any) => {
      setShowCalendar(!showCalendar);
    };

      const handleCheckboxChange = () => {
    setMyJobsOnly((prev:any) => !prev);
  };

   const isAdmin = useMemo(()=>{
    return (profile?.extraProperties?.IsAdmin == true || profile?.extraProperties?.IsSuperAdmin == true)
   },[profile])
  return (
    <Row>
      <Col xs={12}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          {/* <button onClick={()=>{setMyJobsOnly((prev:boolean)=>!prev)}} className={`employee-job-button ${myJobsOnly ? "employee-job" : ""}`}><FeatherIcon icon={myJobsOnly ? "users" : "user"}/> {myJobsOnly ? "Show All Jobs" : "Show My Jobs"}</button> */}
    {hasAdminOrEmployeeRoleHandler() && <div className="job-tab-container">
      <button
        className={`job-tab ${!myJobsOnly ? "active" : ""}`}
        onClick={() => setMyJobsOnly(false)}
      >
        <FeatherIcon icon="users" size={16} /> Show All Jobs
      </button>
            <button
        className={`job-tab ${myJobsOnly ? "active" : ""}`}
        onClick={() => setMyJobsOnly(true)}
      >
        <FeatherIcon icon="user" size={16} />{isAdmin ? "Show Individual Jobs" : "Show My Jobs"}
      </button>

    </div>}
            <div className="d-flex align-items-center gap-2">
          <h4 className="mb-0 font-size-18">{breadcrumbItem}</h4>
          <div id="calendar">
          <div className="table-header-container-item">
                  <div className="btn-group">
                      <button
                          className="btn btn-soft-primary waves-effect waves-light"
                          // onClick={toggleCalendar}
                          onClick={(e) => calendarRef.current.toggle(e)}
                          >
                          <i className="bx bx-calendar font-size-16 align-middle"></i>
                      </button>
                  </div>
                </div>
                </div>
                <OverlayPanel ref={calendarRef}>
                  {/* <Calendar value={date} onChange={(e:any) => setDate(e.value)} view="month" dateFormat="mm/yy" className="dashboard-calendar"/> */}
                  <label htmlFor="month">Select Month</label>
                  <Row>
                                <input
                                  className="form-control"
                                  type="month"
                                  name="month"
                                  value={date||monthConverter()}
                                  onChange={(e)=>setDate(e.target.value)}
                                />
                                </Row>
                  </OverlayPanel>
                <b className="jobsheet-date">{convertToMonthYear(date)}</b>
                
                 {/* <InputSwitch checked={myJobsOnly} onChange={(e) => setMyJobsOnly(e.value)} /> */}
                </div>
          <div className="page-title-right" id="Dashboardbrteadcrumb">
            <ol className="breadcrumb m-0">

              {title &&
                <>
                  <BreadcrumbItem>
                    {/* <Link to={titlePath ? titlePath : title}>{title}</Link> */}
  
                  </BreadcrumbItem>

                  {/* <BreadcrumbItem active>
                    <Link to="#">
                      {breadcrumbItem}
                    </Link>
                  </BreadcrumbItem> */}
                </>
              }
              <div className="btn-group">
                      <button
                          className="btn btn-soft-primary waves-effect waves-light"
                          // onClick={toggleCalendar}
                          onClick={(e) => setShowDetail((prev:any)=>!prev)}
                          >
                          {showDetail ? <i className='bx bxs-chevrons-up'></i> :  <i className='bx bxs-chevrons-down'></i>}
                      </button>
                  </div>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default DashboardBreadcrumb;
